import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Button, Col, FloatingLabel, Form, Row, Table} from 'react-bootstrap';
import {FmlxIcon} from 'fmlx-common-ui';
import {API_CONSOLIDATION_DETAIL} from '../../const/Api';
import LoadingComponent from '../../components/LoadingComponent';
import {useDispatch, useSelector} from 'react-redux';
import {ALERT_VARIANT, QUESTION_TYPE, REVIEW_TYPE} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {Get} from '../../lib/Request';
import {exportPdf} from '../../stores/business/consolidationBusiness';

export default function ConsolidationView() {
  const {authToken} = useSelector((state) => ({
    userId: state.appState.user.id,
    authToken: state.appState.authtoken,
    userAuthRoleId: state.appState.user.authRole?.id,
  }));
  const dispatch = useDispatch();

  const [reviewList, setReviewList] = useState([]);
  const [loadingEmployee, setLoadingEmployee] = useState(true);
  const [consolidationData, setConsolidationData] = useState({});
  const history = useHistory();

  const location = useLocation();
  const employeeID = location.state?.employeeId;
  const periodID = location.state?.periodId;
  const [isExportPdfLoading, setIsExportPdfLoading] = useState(false);

  useEffect(() => {
    var mounted = true;
    if (!employeeID || !periodID) {
      history.goBack();
    }
    if (mounted) {
      // populateData();
      populateReviewData();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [employeeID, history, periodID]);

  // function goBack() {
  //   history.goBack();
  // }

  async function populateReviewData() {
    setLoadingEmployee(true);
    try {
      const response = await Get(`${API_CONSOLIDATION_DETAIL}/${employeeID}/${periodID}`);
      setReviewList(response);
      setConsolidationData(response)
      console.log("this is response from api ", response);

    } catch (error) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: error.message,
        })
      );
    } finally {
      setLoadingEmployee(false);
    }
  }

  const onExportPdfClickHandler = async () => {
    setIsExportPdfLoading(true);
    await exportPdf(dispatch, reviewList, authToken);
    await dispatch(exportPdf(reviewList, authToken));
    setIsExportPdfLoading(false);
  };

  // const onExportPdfDetailClickHandler = async () => {
  //   setIsExportPdfLoading(true);
  //   await dispatch(exportPdfDetail(reviewList, authToken, userAuthRoleId));
  //   setIsExportPdfLoading(false);
  // };

  const review_information = (
    <div>
      Review Information
      <Row>
        <Col md={4} sm={12}>
          <Form.Group size="lg" className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Reviewer"
              value={loadingEmployee ? '-' : reviewList.employeeName}
              disabled
              readOnly
            />
          </Form.Group>
        </Col>
        <Col md={4} sm={12}>
          <Form.Group size="lg" className="mb-2">
            <Form.Label>Period</Form.Label>
            <Form.Control type="text" placeholder="Reviewer" value={reviewList.periodName} disabled readOnly/>
          </Form.Group>
        </Col>
        {consolidationData.reviewDate !== null && (
          <Col md={4} sm={12}>
            <div style={{marginTop: '30px', whiteSpace: 'nowrap', display: 'flex', gap: '8px'}}>
              {!loadingEmployee && (
                <>
                  <Button
                    disabled={isExportPdfLoading}
                    style={{width: '100px'}}
                    variant="danger"
                    onClick={onExportPdfClickHandler}
                  >
                    {isExportPdfLoading ? (
                      <div>
                        <span
                          style={{marginLeft: '0px'}}
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </div>
                    ) : (
                      <>
                        PDF <FmlxIcon name={'Download'} customColor={'#fafafa'}/>
                      </>
                    )}
                  </Button>
                </>
              )}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );

  function review_table(data, loading) {
    return (
      <div className="mt-4">
        {loading ? (
          <div className="text-center">
            <LoadingComponent/>
          </div>
        ) : data.length === 0 ? (
          <div className="text-center">Nothing to display</div>
        ) : (
          <React.Fragment>
            {data.generalReviews.map((review) => (
              <div key={`general-question-${review.questionId}`}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    wordBreak: 'break-word',
                  }}
                >
                  {review.questionTitle}
                </div>
                <div style={{fontSize: '18px', fontWeight: 'bold'}}>{review.title}</div>
                <div style={{fontSize: '14px'}} className="mt-4">
                  {review.questionDescription}
                </div>
                <Table hover className="mb-4 mt-2">
                  <thead>
                  <tr>
                    <th width="*">Name</th>
                    <th width="150">Relation</th>
                    {review.questionType === QUESTION_TYPE.ESSAY ? (
                      <th width="400">Notes</th>
                    ) : (
                      <React.Fragment>
                        <th width="100">Score</th>
                        <th width="400">Notes</th>
                      </React.Fragment>
                    )}
                  </tr>
                  </thead>
                  <tbody>
                  {review?.answers?.map((answer, indexData) => (
                    <>
                      <tr key={`question-${indexData}`}>
                        <td>{answer.reviewType === REVIEW_TYPE.CONS.Id ? 'Final Score' : answer.employeeName}</td>
                        <td>{answer.reviewType}</td>
                        {review.questionType === QUESTION_TYPE.ESSAY ? (
                          <></>
                        ) : (
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Score">
                              <Form.Control
                                type="number"
                                max={
                                  review.questionType === QUESTION_TYPE.SCORE_5
                                    ? 5
                                    : review.questionType === QUESTION_TYPE.SCORE_10
                                      ? 10
                                      : review.questionType === QUESTION_TYPE.SCORE_20
                                        ? 20
                                        : 4
                                }
                                min={0}
                                disabled
                                placeholder="Score"
                                value={answer?.score}
                              />
                            </FloatingLabel>
                          </td>
                        )}
                        <td>
                          <FloatingLabel controlId="floatingTextarea2" label="Notes">
                            <Form.Control
                              as="textarea"
                              disabled
                              placeholder="Notes"
                              style={{height: '100px'}}
                              value={answer?.comment ?? ''}
                            />
                          </FloatingLabel>
                        </td>
                      </tr>
                    </>
                  ))}
                  {review.questionType !== QUESTION_TYPE.ESSAY ? (
                    <tr key={`final-score-${review.questionId}`}>
                      <td>Final Score</td>
                      <td>Consolidation</td>
                      <td>
                        <FloatingLabel controlId="floatingTextarea2" label="Score">
                          <Form.Control
                            type="number"
                            max={
                              review.questionType === QUESTION_TYPE.SCORE_5
                                ? 5
                                : review.questionType === QUESTION_TYPE.SCORE_10
                                  ? 10
                                  : review.questionType === QUESTION_TYPE.SCORE_20
                                    ? 20
                                    : 4
                            }
                            min={0}
                            disabled
                            placeholder="Score"
                            value={review.scoreConsolidation}
                          />
                        </FloatingLabel>
                      </td>
                      <td>
                        <></>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                  </tbody>
                </Table>
              </div>
            ))}
            {data.skillReviews.map((review) => (
              <div key={`skill-question-${review.questionId}`}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    wordBreak: 'break-word',
                  }}
                >
                  {review.questionTitle}
                </div>
                <div style={{fontSize: '18px', fontWeight: 'bold'}}>{review.title}</div>
                <div style={{fontSize: '14px'}} className="mt-4">
                  {review.questionDescription}
                </div>
                <Table hover className="mb-4 mt-2">
                  <thead>
                  <tr>
                    <th width="*">Name</th>
                    <th width="150">Relation</th>
                    {review.questionType === QUESTION_TYPE.ESSAY ? (
                      <th width="400">Notes</th>
                    ) : (
                      <React.Fragment>
                        <th width="100">Score</th>
                        <th width="400">Notes</th>
                      </React.Fragment>
                    )}
                  </tr>
                  </thead>
                  <tbody>
                  {review?.answers.map((answer) => (
                    <>
                      <tr key={`question-${answer}`}>
                        <td>{answer.employeeName}</td>
                        <td>{answer.reviewType}</td>
                        {review.questionType === QUESTION_TYPE.ESSAY ? (
                          <></>
                        ) : (
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Score">
                              <Form.Control
                                type="number"
                                max={
                                  review.questionType === QUESTION_TYPE.SCORE_3
                                    ? 3
                                    : review.questionType === QUESTION_TYPE.SCORE_10
                                      ? 10
                                      : review.questionType === QUESTION_TYPE.SCORE_20
                                        ? 20
                                        : 4
                                }
                                min={0}
                                disabled
                                placeholder="Score"
                                value={answer?.score}
                              />
                            </FloatingLabel>
                          </td>
                        )}
                        <td>
                          <FloatingLabel controlId="floatingTextarea2" label="Notes">
                            <Form.Control
                              as="textarea"
                              disabled
                              placeholder="Notes"
                              style={{height: '100px'}}
                              value={answer?.comment ?? ''}
                            />
                          </FloatingLabel>
                        </td>
                      </tr>
                    </>
                  ))}
                  {review.questionType !== QUESTION_TYPE.ESSAY ? (
                    <tr key={`final-score-${review.questionId}`}>
                      <td>Final Score</td>
                      <td>Consolidation</td>
                      <td>
                        <FloatingLabel controlId="floatingTextarea2" label="Score">
                          <Form.Control
                            type="number"
                            max={
                              review.questionType === QUESTION_TYPE.SCORE_5
                                ? 5
                                : review.questionType === QUESTION_TYPE.SCORE_10
                                  ? 10
                                  : review.questionType === QUESTION_TYPE.SCORE_20
                                    ? 20
                                    : 4
                            }
                            min={0}
                            disabled
                            placeholder="Score"
                            value={review.scoreConsolidation}
                          />
                        </FloatingLabel>
                      </td>
                      <td>
                        <></>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                  </tbody>
                </Table>
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    );
  }

  return (
    <div className="container mb-4">
      {review_information}
      {review_table(reviewList, loadingEmployee)}
    </div>
  );
}
